/**
 * Main router entry point
 * 
 * Author: Sahil David <sahil.david@huumun.com>
 */

import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import { analyticsRouteTrack } from '@/core/modules/analytics/services/analytics.route.track';

/**
 * Pre-built views
 */
const NotFound = () => import('@/core/views/NotFound.vue');

/**
 * Set sections homepage for packaging purposes
 */
let redirect = '/covid-hub/home';
try {
	const argumentsConfig: any = require('../../core/modules/arguments/data/arguments.json');
	redirect = argumentsConfig.path && argumentsConfig.path !== '' && argumentsConfig.packaging !== 'false' ? argumentsConfig.path : redirect;
} catch (err) {
	console.warn(err);
}

/**
 * Route main object
 */
const routes: Array<RouteRecordRaw> = [
	/**
	 * For making an application route, add redirect property to the route path
	 * to the landing-page route
	 */
	{
		path: '/',
		name: 'landing-page',
		redirect
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'not-found',
		component: NotFound,
	}
];

const router = createRouter({
	history: createWebHashHistory(),
	routes
});

// Navigation guard - Redirect Logic
router.beforeEach((to: any, from: any, next: any) => {
	// Tracking Route
	analyticsRouteTrack(to);

	// Redirect Query
	const { query } = to;
	const { redirect } = query;

	if (redirect) { next(redirect); }
	else { next(); }
});

export default router;